'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import '../css/globals.css';

// We can't use metadata in client components
// export const metadata: Metadata = {
//   title: 'Error',
//   description: 'An error occurred',
// }

export default function GlobalError({
  error,
  reset
}: {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error);
  }, [error]);
  return <html lang="en" data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <head>
        <title>Error | Image Milano</title>
      </head>
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen px-4 py-12 text-center bg-background">
          <h1 className="mb-6 text-offblack">Something went wrong!</h1>
          <p className="text-gray-600 mb-8 max-w-md">
            We apologize for the inconvenience. The system encountered an unexpected error.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button className="px-6 py-2 bg-offblack text-white rounded-md hover:bg-gray-800 transition-colors" onClick={() => reset()}>
              Try again
            </button>

            <a href="/" className="px-6 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors">
              Return to Home
            </a>

            <a href="mailto:services@masukomi.io" className="px-6 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors">
              Contact Support
            </a>
          </div>
        </div>
      </body>
    </html>;
}